import { render } from "./CheckCoverage.vue?vue&type=template&id=3b84abcf"
import script from "./CheckCoverage.vue?vue&type=script&lang=js"
export * from "./CheckCoverage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/marc.bush/Sites/ensotyres/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__